/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Plan_UpgradedInputs */



/**
* | output |
* | --- |
* | "Plan upgraded." |
*
* @param {Partner_Manage_Plan_UpgradedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_upgraded = /** @type {((inputs?: Partner_Manage_Plan_UpgradedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_UpgradedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarif hochgestuft.")
	return /** @type {LocalizedString} */ ("Plan upgraded.")
});